import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Link } from '@mui/material';
import { ArrowCheckIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconDirection, IconSize } from 'constants/coreDesignSystem';

import { backButtonStyles } from './BackButton.styles';

const BackButton = ({ to, dataTestId, ...props }) => (
  <Link
    component={RouterLink}
    data-testid={dataTestId}
    sx={backButtonStyles}
    to={to}
    underline="none"
    {...props}
  >
    <ArrowCheckIcon direction={IconDirection.LEFT} size={IconSize[16]} />
    Back
  </Link>
);

BackButton.propTypes = {
  to: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
};

export default BackButton;
